import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 634EE7E8-8280-4CF1-B642-0921E740B6DB
 * name airplane-landing
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airplane-landing.svg
 * tags
 * - Transportation + Flying 
 */
export const AirplaneLandingIcon = createSvgIcon(<><path d="M2.5,19H21.5V21H2.5V19M9.68,13.27L14.03,14.43L19.34,15.85C20.14,16.06 20.96,15.59 21.18,14.79C21.39,14 20.92,13.17 20.12,12.95L14.81,11.53L12.05,2.5L10.12,2V10.28L5.15,8.95L4.22,6.63L2.77,6.24V11.41L4.37,11.84L9.68,13.27Z" /></>, 'AirplaneLandingIcon');
export default AirplaneLandingIcon